import { StyledText } from '../../../atoms/Text/StyledText';
import { StyledButton } from '../../../atoms/Button/StyledButton';
import { StyledButtonsWrapper } from '../../../atoms/Payments/StyledButtonsWrapper';
import { StyledUPopupCloseButton } from '../../../atoms/Payments/StyledUPopupCloseButton';

import PaymentsPopup from '../../Payments/PaymentsPopup';
import { StyledInputEditWrapper } from '../../../atoms/SummaryElement/StyledInputEditWrapper';

const DeleteHourConfirmationPopup = ({
    confirmPopup,
    setConfirmPopup,
    handleDelete,
    hour,
    isAdmin,
    deleteHour,
    reason,
    setReason,
    textareaError,
    setTextareaError,
    getString,
}) => {
    if (!confirmPopup) return null;
    return (
        <PaymentsPopup>
            <div
                style={{
                    widht: '100%',
                    height: '100%',
                    paddingBottom: '20px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    flex: 1,
                }}
            >
                <StyledText
                    hasdeclaredfontsize="18px"
                    hasdeclaredpadding="50px 20px 50px 20px"
                    hasdeclaredlineheight="1.4em"
                    hasdeclaredtextalign="center"
                >
                    {getString('summary_edit_element_czy_na_pewno')}
                </StyledText>
                {!isAdmin ? (
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            flexDirection: 'column',
                            gap: '10px',
                            paddingBottom: '30px',
                        }}
                    >
                        <StyledText hasdeclaredlineheight="1.4em" hasdeclaredtextalign="center">
                            {getString('summary_edit_element_podaj_powod')}
                        </StyledText>
                        <StyledInputEditWrapper>
                            <textarea
                                style={{
                                    width: '300px',
                                    height: '100px',
                                    resize: 'none',
                                    border: `2px solid ${textareaError ? 'red' : '#6786BE'}`,
                                    borderRadius: '12px',
                                    padding: '12px',
                                    fontSize: '16px',
                                    fontFamily: 'Poppins',
                                }}
                                type="text"
                                onChange={(e) => setReason(e.target.value)}
                            />
                        </StyledInputEditWrapper>
                    </div>
                ) : null}
                <StyledButtonsWrapper>
                    <StyledButton
                        onClick={() =>
                            handleDelete(
                                hour.id,
                                isAdmin,
                                deleteHour,
                                confirmPopup,
                                setConfirmPopup,
                                reason,
                                setTextareaError
                            )
                        }
                    >
                        USUŃ
                    </StyledButton>
                    <StyledUPopupCloseButton onClick={() => setConfirmPopup(false)}>
                        <StyledText
                            hasdeclaredfontsize="18px"
                            hasdeclaredtextalign="center"
                            hasdeclaredfontweight="700"
                            hasdeclaredfontcolor="#fff"
                            hascursor="pointer"
                        >
                            {getString('payments_paymentsPopup_zamknij')}
                        </StyledText>
                    </StyledUPopupCloseButton>
                </StyledButtonsWrapper>
            </div>
        </PaymentsPopup>
    );
};

export default DeleteHourConfirmationPopup;
